module.exports = __webpack_public_path__ + "static/media/cssScaffolding.e094a9b3.md";